module.exports = __webpack_public_path__ + "static/media/video_low_eng.25e55d66.mp4";